import React from "react";

interface IconProps {
    className?: string;
  }

const PaintBrushIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    className={className}
  >
    <g>
      <g>
        <path d="M499.377,46.402c-8.014-8.006-18.662-12.485-29.985-12.613c-0.166-0.002-0.331-0.003-0.496-0.003
           c-11.142,0-21.698,4.229-29.771,11.945L198.872,275.458c25.716,6.555,47.683,23.057,62.044,47.196
           c4.376,7.356,7.859,15.143,10.453,23.179l228.691-239.172C507.759,98.604,512,88.031,512,76.89
           C512,65.383,507.522,54.56,499.377,46.402z"
        />
      </g>
    </g>
    <g>
      <g>
        <path d="M176.588,302.344c-1.209-0.051-2.418-0.076-3.626-0.076c-20.273,0-40.381,7.05-56.784,18.851
           c-19.772,14.225-27.656,34.656-42.174,53.27C55.8,397.728,27.795,409.14,0,416.923c16.187,42.781,76.32,60.297,115.752,61.24
           c1.416,0.034,2.839,0.051,4.273,0.051c44.646,0,97.233-16.594,118.755-60.522C262.408,369.468,233.284,304.717,176.588,302.344z"
        />
      </g>
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>

);

export default PaintBrushIcon;
